import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";

const controller = rpcController("ClientePaquete");
const crud = rpcCrudService<models.DireccionCliente, models.DireccionClienteDTO>(controller);

export const ClientePaquete = cacheResource({


    ObtenerClienteDescripcionesPaquetes: async (idCliente: number): Promise<models.ClienteDescripcionPaqueteDTO[]> => await controller("ObtenerClienteDescripcionesPaquetes", { idCliente }),
    DescripcionesPaquetesClientePuedeAgregar: async (idCliente: number): Promise<models.DescripcionPaqueteDTO[]> => await controller("DescripcionesPaquetesClientePuedeAgregar", { idCliente }),

    Add: async (idCliente: number, idDescripcionesPaquetes: number[]): Promise<void> => await controller("Add", { idCliente }, idDescripcionesPaquetes),

    Delete: async (id: number): Promise<void> => await controller("Delete", { id }),


},
    {
        ObtenerClienteDescripcionesPaquetes: true,
        DescripcionesPaquetesClientePuedeAgregar: true,
    }, {
        Add: true,
        Delete: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/clientedescripcionespaquetes.tsx